import type { AzureRestorePointDataRestorePointTypeEnum } from '@repo/api-gw-sdk';

export function formatRestorePointType(
  type: AzureRestorePointDataRestorePointTypeEnum
): string {
  const types: Record<AzureRestorePointDataRestorePointTypeEnum, string> = {
    compute: 'Restore Point',
    recovery_services: 'Recovery Point',
  };
  return types[type];
}

export function extractDiskName(diskId: string): string {
  return diskId.split('/').pop() || diskId;
}
